import { Alert } from '@avantstay/backoffice-core'

import { trackError } from '@tracking/customEventReport'

export const apiError = (error: unknown, fallback: string) =>
  (error instanceof Error && error.message.trim()) || fallback

interface StoreErrorParams {
  action: string
  error: unknown
  context?: Record<string, unknown>
  userMessage?: string
}

export const handleStoreError = ({ action, error, context, userMessage }: StoreErrorParams) => {
  trackError(action, { ...context, error })

  if (userMessage) Alert.Error(apiError(error, userMessage))
}
